import React from 'react';

const BusinessNeed = ({ BusinessNeedData }) => {
  const { title, bold, bold2, bold3, bold4, description, description2, description3, description4 } = BusinessNeedData;

  return (
    <section className="business-need">
      <div className="container">
        <div className="business-need-wrapper">
          <div className="heading">
            <h2>{title}</h2>
          </div>
          <p><b>{bold}</b> {description}</p>
           <p><b>{bold2}</b> {description2}</p>
            <p><b>{bold3}</b> {description3}</p>
             <p><b>{bold4}</b> {description4}</p>
         
        </div>
      </div>
    </section>
  );
};

export default BusinessNeed;
